import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers } from "redux";
// Import the ESM build, not `redux-persist/lib/storage`. `lib/` is CommonJS
// (`exports.default = ...`), and under Vite 8's interop the default import
// resolves to the module namespace instead of the storage object, so
// `storage.getItem` comes back undefined and persistStore() throws. It also
// matches how the bare `redux-persist` import above resolves (via `module`),
// so only one copy of the library is loaded.
import storage from "redux-persist/es/storage";
import userReducer from "./authSlice";

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['agent'],
};

const rootReducer = combineReducers({
    auth: userReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
